import { Link } from "react-router-dom";

function renderBlock(block, index) {
  switch (block.type) {
    case "h2":
      return <h2 key={index}>{block.text}</h2>;
    case "h3":
      return <h3 key={index}>{block.text}</h3>;
    case "h4":
      return <h4 key={index}>{block.text}</h4>;
    case "p":
      if (block.html) {
        return <p key={index} dangerouslySetInnerHTML={{ __html: block.html }} />;
      }
      return <p key={index}>{block.text}</p>;
    case "ul":
      return (
        <ul key={index}>
          {block.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      );
    default:
      return null;
  }
}

export function LegalDocument({ legal }) {
  return (
    <div className="legal-page">
      <p className="legal-switch-link">
        <Link to={legal.switchLink.to}>{legal.switchLink.text}</Link>
      </p>
      <article className="legal-doc">{legal.blocks.map(renderBlock)}</article>
    </div>
  );
}
